import { Ambassador } from 'src/models/FundraisingModel';
import { AnyAction } from 'redux';
import {
  ADD_AMBASSADOR,
  REMOVE_AMBASSADOR,
  REPLACE_AMBASSADOR, SET_AMBASADOR_LIST,
} from '../actions/ambassadorActions';

const DEFAULT = [] as Ambassador[];

const AmbassadorsReducer = (state = DEFAULT, action: AnyAction) => {
  switch (action.type) {
    case SET_AMBASADOR_LIST:
      return [...action.payload] as Ambassador[];
    case ADD_AMBASSADOR: {
      return [
        ...state, action.payload as Ambassador,
      ];
    }
    case REPLACE_AMBASSADOR:
      return state.map((ambassador) => (ambassador.id === action.payload.id ? action.payload : ambassador));
      break;

    case REMOVE_AMBASSADOR: {
      const newState = state.filter((ambassador) => ambassador.id !== action.payload);
      return [
        ...newState,
      ];
      break;
    }
    default:
      return state;
  }
};

export default AmbassadorsReducer;
